import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "logo-tile",
    style: _normalizeStyle({ width: _ctx.size + 'px', height: _ctx.size + 'px', borderRadius: _ctx.radius + 'px' })
  }, [
    (_ctx.logo)
      ? (_openBlock(), _createBlock(_component_v_img, {
          key: 0,
          src: _ctx.logo,
          alt: _ctx.alt,
          contain: ""
        }, null, 8, ["src", "alt"]))
      : (_ctx.icon)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 1,
            icon: _ctx.icon,
            class: "logo-tile__icon"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
  ], 4))
}